import { instance } from './index';

export const reportsAPI = {
  featuredFlights () {
    return instance.get('reports/featured-flights');
  },
  network (tab) {
    return instance.get(`reports/network/${tab}`);
  },
  offsetPurchases () {
    return instance.get('reports/offsetPurchases');
  },
  apRequests () {
    return instance.get('reports/apRequests');
  },
  flightReqs () {
    return instance.get('reports/flightReqs');
  },
  routeAlerts () {
    return instance.get('reports/route-alerts');
  },
  reservations () {
    return instance.get('reports/reservations');
  },
  confirmedReservations () {
    return instance.get('reports/confirmed-reservations');
  },
  bookings () {
    return instance.get('reports/bookings');
  },
  confirmations () {
    return instance.get('reports/confirmations');
  },
  flycal () {
    return instance.get('reports/flyCalRequests');
  },
  ctaEmails () {
    return instance.get('reports/ctaEmails');
  },
  litquiditySignup () {
    return instance.get('litquidity-signup');
  },
  flightGroupSignup () {
    return instance.get('flight-group-signup');
  },
  flightShareRequests () {
    return instance.get('winter-shares/requests/false');
  },
  flightLitShareRequests () {
    return instance.get('winter-shares/requests/true');
  },
  groupedFlightShareRequests () {
    return instance.get('winter-shares/requests/grouped-by-routes');
  },
  subscriptions () {
    return instance.get('reports/subscriptions')
  },
  revenue () {
    return instance.get('reports/revenueSubscriptions')
  },
  subscriptionAnalytics () {
    return instance.get('reports/subscriptionAnalytics');
  },
  discountRequests () {
    return instance.get('reports/discountRequests');
  },
  exchangeMembershipApps () {
    return instance.get('reports/exchangeMembershipApplications');
  },
  exchangeOffers (type, historical) {
    return instance.get(`reports/${type}/${historical}`);
  },
}
